import React from "react";
import ImageIcon from "@mui/icons-material/Image";
import SendIcon from "@mui/icons-material/Send";

export type ChatMsg = { role: "user" | "assistant"; content: string; history?: string };

type ChatPanelProps = {
  messages: ChatMsg[];
  onSend?: (text: string) => void;
  belowMessages?: React.ReactNode;
};

const ChatPanel: React.FC<ChatPanelProps> = ({ messages, onSend, belowMessages }) => {
  const [text, setText] = React.useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const v = text.trim();
    if (!v) return;
    onSend?.(v);
    setText("");
  };

  return (
    <div className="h-full flex flex-col border-r border-gray-300 bg-white">
      {/* メッセージ一覧 */}
      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-2">
        {messages.map((m, i) => (
          <div
            key={i}
            className={`px-3 py-2 rounded-lg w-fit max-w-[75%] ${
              m.role === "user"
                ? "self-end bg-green-100 text-right"
                : "self-start bg-blue-100 text-left"
            }`}
          >
            {m.history && (
              <div className="text-[11px] text-gray-600 mb-0.5 leading-tight">{m.history}</div>
            )}
            <div style={{ whiteSpace: "pre-line" }}>{m.content}</div>
          </div>
        ))}
        {belowMessages && <div className="mt-3">{belowMessages}</div>}
      </div>

      {/* 入力欄 */}
      <div className="p-3 border-t border-gray-200 bg-white">
        <form onSubmit={handleSubmit} className="flex items-center gap-2">
          <input
            type="text"
            placeholder="メッセージを入力..."
            className="flex-1 px-4 py-2 text-sm rounded-full border border-gray-300 bg-white outline-none"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button
            type="button"
            className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 bg-white hover:bg-gray-100"
          >
            <ImageIcon fontSize="small" className="text-gray-600" />
          </button>
          <button
            type="submit"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-300 hover:bg-gray-400"
          >
            <SendIcon fontSize="small" className="text-white" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatPanel;
